import api from "!../../../../../../../voicecasting.sk/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../voicecasting.sk/node_modules/css-loader/dist/cjs.js??clonedRuleSet-19[0].rules[0].use[1]!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../voicecasting.sk/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-19[0].rules[0].use[2]!../../../../../../../voicecasting.sk/node_modules/less-loader/dist/cjs.js!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/index.js??vue-loader-options!./ProjectActorDialogShortlist.vue?vue&type=style&index=0&id=3bb50f20&lang=less&scoped=true&";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};